export * from './utils/version-page-info';
export * from './utils/generation-group-detail-url';
export const isNullish = (value) => value === undefined || value === null;
export const bem = (block) => {
    return {
        b: block,
        e(element) {
            return `${block}__${element}`;
        },
        m(modifier) {
            return `${block}--${modifier}`;
        },
        em(element, modifier) {
            return `${block}__${element}--${modifier}`;
        },
    };
};
export const uuid = (prefix = '', length = 5) => `${prefix}${Math.random()
    .toString()
    .substring(2, 2 + length)}`;
export const numberFormat = (value) => typeof value === 'string' ? parseFloat(value) : value;
export const relationDescription = (type, removeName, addName, ...names) => {
    const prefixName = removeName && addName
        ? `如添加${addName}且移除${removeName}`
        : removeName
            ? `如移除${removeName}`
            : addName
                ? `如添加${addName}`
                : null;
    if (!prefixName)
        return;
    switch (type) {
        case 0 /* RelationShip.mutex */:
            return `${prefixName}将移除${names[0]}`;
        case 1 /* RelationShip.bind */:
            return `${prefixName}将同时添加${names[0]}`;
        case 2 /* RelationShip.mutexBind */:
            return `${prefixName}将移除${names[0]}，并同时添加${names[1]}`;
    }
};
export const newRelationDescription = (type, removeName, addName, ...names) => {
    const prefixName = removeName && addName
        ? `${removeName}另需搭配${addName}，如需取消，请至内饰更改`
        : '';
    switch (type) {
        case 3 /* RelationShip.relationReverse */:
            return `${prefixName}`;
    }
};
export const isEmptyObject = (value) => typeof value === 'object' && value !== null && Object.keys(value).length === 0;
export const isEmpty = (value) => {
    if (value === '')
        return true;
    if (value === 'null')
        return true;
    if (value === 'undefined')
        return true;
    if (!value && value !== 0 && value !== '')
        return true;
    if (isEmptyObject(value))
        return true;
    if (Array.isArray(value) && value.length === 0)
        return 0;
};
export const optionSort = (newOptions, oldOptions) => {
    newOptions.sort((a, b) => {
        return a?.code - b?.code;
    });
    oldOptions.sort((a, b) => {
        return a?.code - b?.code;
    });
    return isEqual(newOptions, oldOptions);
};
export const isEqual = (obj1, obj2) => {
    if (typeof obj1 !== typeof obj2)
        return false;
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    return Object.keys(obj1)
        .filter((key1) => key1 !== 'generation_code')
        .every((key1) => {
        if (typeof obj1[key1] === 'object') {
            return isEqual(obj1[key1], obj2[key1]);
        }
        return obj2?.[key1] === obj1?.[key1];
    });
};
// 图片压缩 https://developer.qiniu.com/dora/1279/basic-processing-images-imageview2
export const imgClip = (url, options = {}, h, mode) => {
    if (typeof url !== 'string')
        return url;
    // 便捷参数模式
    if (typeof options !== 'object') {
        options = { w: options };
        h && (options.h = h);
        mode !== undefined && (options.mode = mode);
    }
    // 合并默认参数
    options = {
        mode: 0,
        q: '85!',
        interlace: 1,
        'ignore-error': 1,
        ...options,
    };
    // 处理为无压缩参数链接，防止配置冲突，&可以干掉，?不能干掉
    url = url.replace(/&?imageView2[^&]*/, '');
    // 添加前缀和mode
    url += (/\?/.test(url) ? '&' : '?') + 'imageView2/' + options.mode + '/';
    delete options.mode; // 避免再次添加mode
    // 拼接其他参数
    url += Object.entries(options)
        .map((item) => item.join('/'))
        .join('/');
    return url;
};
/**
 * 获取url参数，针对hash模式,只在h5中使用
 * @returns
 */
export const getUrlParams = () => {
    let urlStr = decodeURI(window.location.search.split('?')[1]);
    let object = {};
    if (urlStr) {
        let strs = urlStr.split('&');
        for (let i = 0; i < strs.length; i++) {
            object[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
    }
    return object;
};
// 获取url上的参数
export const getParamFromUrl = (name, url) => {
    const params = {};
    const urlString = url || window.location.href;
    const hashIndex = urlString.indexOf('#');
    if (hashIndex !== -1) {
        url = urlString.slice(0, hashIndex);
    }
    const queryString = urlString.split('?')[1];
    if (queryString) {
        const keyValuePairs = queryString.split('&');
        for (const keyValue of keyValuePairs) {
            const [key, value = ''] = keyValue.split('=');
            params[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    }
    if (name) {
        return params[name];
    }
    return params;
};
const genStoreKey = (key) => {
    const type = getModelCodeByName(getUrlParams().type ?? '');
    return `car-configuration-${key}${type ? '-' + type : type}`;
};
export const isLg = navigator.userAgent.includes('lg _dsbridge');
export const isCNLg = !!(isLg && /NioAppCN/i.test(navigator.userAgent));
export const customStorage = !!window && !isCNLg
    ? {
        setItem(key, state) {
            return window.sessionStorage?.setItem(genStoreKey(key), state);
        },
        getItem(key) {
            const type = getModelCodeByName(getUrlParams().type);
            const globalStoreData = window.sessionStorage?.getItem(genStoreKey(key)) ?? '';
            if (key !== 'config-global')
                return globalStoreData;
            try {
                const parsedData = JSON.parse(globalStoreData);
                if (type && parsedData?.currentOpts?.model_code !== type) {
                    return '';
                }
                if (parsedData?.showMode) {
                    parsedData.showMode = '3D';
                }
                return JSON.stringify(parsedData);
            }
            catch (err) {
                return '';
            }
        },
        removeItem: window.sessionStorage?.removeItem,
        length: window.sessionStorage?.length,
        clear: window.sessionStorage?.clear,
        key: window.sessionStorage?.key,
    }
    : {};
export const debounceFn = (cb, time = 500) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            cb(...args);
        }, time);
    };
};
export const renderDialogContent = (content) => {
    const arr = [];
    let pre = 0;
    let cur = 0;
    for (let index = 0; index < content.length; index++) {
        if (content[index] !== '{' && content[index] !== '}') {
            cur++;
            if (index == content.length - 1) {
                let item = {
                    content: content.slice(pre),
                    isBold: false,
                };
                arr.push(item);
            }
        }
        else {
            if (pre !== cur) {
                let item = {
                    content: content.slice(pre, cur),
                    isBold: content[index] === '{' ? false : true,
                };
                arr.push(item);
            }
            cur++;
            pre = cur;
        }
    }
    return arr;
};
/**
 * 处理ET5T 映射为TT5
 */
export const getModelCodeByName = (codeName = '') => {
    if (codeName === 'ET5T') {
        return 'TT5';
    }
    return codeName;
};
/**
 * 处理TT5 映射为ET5T
 */
export const getNameByModelCode = (codeName = '') => {
    if (codeName === 'TT5') {
        return 'ET5T';
    }
    return codeName;
};
// 配置项数组去重并移除无用数据
export const concatOptionsList = (newArr, oldArr) => {
    let json = newArr.concat(oldArr); //两个数组对象合并
    let newJson = []; //盛放去重后数据的新数组
    for (const item1 of json) {
        //循环json数组对象的内容
        let flag = true; //建立标记，判断数据是否重复，true为不重复
        for (const item2 of newJson) {
            //循环新数组的内容
            if (item1.featureCode == item2.featureCode) {
                //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
                flag = false;
            }
        }
        if (flag) {
            //判断是否重复
            newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
        }
    }
    newJson.forEach((item) => {
        const hasOption = newArr.some((subItem) => {
            return subItem.featureCode == item.featureCode;
        });
        if (!hasOption) {
            item.selected = false;
        }
    });
    return newJson;
};
